import React from 'react'
import CalendarDatePickerSelectBox from './CalendarDatePickerSelectBox'
import CalendarFilterFullSizeDropdown from './CalendarFilterFullSizeDropdown'
import CalendarDatePicker from './CalendarDatePicker'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'

interface Props {
  open: boolean;
  offsetDropdown?: boolean;
  useRooms?: boolean;
  defaultDayPicker?: boolean;
  defaultMonth?: string;
}

function CalendarDatePickerSelect(props: Props) {
  const {
    open,
    offsetDropdown,
  } = props

  return (<div>
    <CalendarDatePickerSelectBox />
    <CalendarFilterFullSizeDropdown
      open={open}
      offset={offsetDropdown}
      data-testid="offer-checkin-select"
    >
      <CalendarDatePicker />
    </CalendarFilterFullSizeDropdown>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'datepicker',
}))(CalendarDatePickerSelect)
